"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIDfromProps = exports.getUUIDfromProps = exports.reconcileState = exports.replaceByUuidWithIndexes = exports.replaceByUuid = exports.replaceByIdFromArray = exports.replaceById = void 0;
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var replaceById = function (rows, newElement) {
    var newRows = __spreadArray([], rows, true);
    var existing = newRows.findIndex(function (n) { return n.id === newElement.id; });
    if (existing !== -1) {
        newRows[existing] = newElement;
    }
    return newRows;
};
exports.replaceById = replaceById;
var replaceByIdFromArray = function (rows, newElements) {
    var newRows = __spreadArray([], rows, true);
    var _loop_1 = function (element) {
        var existing = newRows.findIndex(function (n) { return n.id === element.id; });
        if (existing === -1) {
            return "continue";
        }
        newRows[existing] = element;
    };
    for (var _i = 0, newElements_1 = newElements; _i < newElements_1.length; _i++) {
        var element = newElements_1[_i];
        _loop_1(element);
    }
    return newRows;
};
exports.replaceByIdFromArray = replaceByIdFromArray;
var replaceByUuidFull = function (rows, newElements) {
    var newRows = __spreadArray([], rows, true);
    var updatedIndexes = [];
    var _loop_2 = function (element) {
        var existing = newRows.findIndex(function (n) { return n.uuid === element.uuid; });
        if (existing > -1) {
            updatedIndexes.push(existing);
            newRows[existing] = element;
        }
        else {
            updatedIndexes.push(newRows.length);
            newRows.push(element);
        }
    };
    for (var _i = 0, newElements_2 = newElements; _i < newElements_2.length; _i++) {
        var element = newElements_2[_i];
        _loop_2(element);
    }
    return { indexes: updatedIndexes, rows: newRows };
};
var replaceByUuid = function (rows, newElements) {
    return replaceByUuidFull(rows, newElements).rows;
};
exports.replaceByUuid = replaceByUuid;
var replaceByUuidWithIndexes = function (rows, newElements) {
    return replaceByUuidFull(rows, newElements);
};
exports.replaceByUuidWithIndexes = replaceByUuidWithIndexes;
var reconcileState = function (state, initialState) {
    var newState = __assign({}, state);
    for (var prop in newState) {
        if ((0, isEqual_1.default)(newState[prop], initialState[prop])) {
            delete newState[prop];
        }
    }
    return newState;
};
exports.reconcileState = reconcileState;
var getUUIDfromProps = function (_state, _a) {
    var uuid = _a.uuid;
    return uuid;
};
exports.getUUIDfromProps = getUUIDfromProps;
var getIDfromProps = function (_state, _a) {
    var id = _a.id;
    return id;
};
exports.getIDfromProps = getIDfromProps;
